
/**
 * Created by klyachb1 on 23/02/2017.
 */
import {Injectable} from '@angular/core';
import {CanActivate, RouterStateSnapshot, ActivatedRouteSnapshot} from '@angular/router';
import {LoginService} from '../shared/services/login.service';
import {Router} from '@angular/router';
import {CanActivateBase} from './can-activate-via-auth-guard';

@Injectable()
export class CanActivateIfTechCSOGuard extends CanActivateBase {

  constructor(protected loginService: LoginService, protected router: Router) {
    super(loginService, router);
  }

  doActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (this.loginService.isUserLoggedIn()) {
      return this.loginService.isAdminUserLoggedIn() ||
        this.loginService.isSystemAdminUserLoggedIn() ||
        this.loginService.isTechCSOUserLoggedIn();
    } else {
      this.router.navigate(['/login'], {queryParams: {returnUrl: state.url}});
      return false;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/guards/can-activate-if-techcso-guard.ts